import classnames from 'classnames';
import NoData from 'components/content/NoData';
import { isNumber } from 'remeda';

import EmptyResult from './EmptyResult';
import type { SearchedVehicle } from './types';
import VehicleComponent from './Vehicle';

import './styles/VehiclesList.scss';

interface Props {
    fatals?: SearchedVehicle[];
    errors?: SearchedVehicle[];
    warnings?: SearchedVehicle[];
    online?: SearchedVehicle[];
    offline?: SearchedVehicle[];
    total?: number;
    searchInput?: string;
    onClick(vin: string): void;
    open?: boolean;
}

const VehicleItem = ({ vehicle, onClick }: { vehicle: SearchedVehicle; onClick: (vin: string) => void }) => (
    <li onClick={() => onClick(vehicle.vin)} className='VehiclesList__item' data-testid='vehicle-search-result'>
        <VehicleComponent
            name={vehicle.name}
            licensePlate={vehicle.licensePlate}
            vin={vehicle.vin}
            connectivityStatus={vehicle.connectivityStatus}
            severity={vehicle.severity}
        />
    </li>
);

const VehiclesList = ({ fatals, errors, warnings, online, offline, total, searchInput, onClick, open }: Props) => {
    if (!isNumber(total)) {
        return null;
    }

    if (!total || total === 0) {
        return <EmptyResult />;
    }

    const groups = [fatals, errors, warnings, online, offline];

    return (
        <ul
            className={classnames('VehiclesList__list', {
                'VehiclesList__list--hidden': !open,
            })}
            data-testid='vehicle-search-list'
            data-state={open ? 'open' : 'closed'}
        >
            <li className='VehiclesList__line VehiclesList__item VehiclesList__item--header VehiclesList__text'>
                {searchInput?.length ? 'Search results' : 'All vehicles'}
                <span className='VehiclesList__text--gray'>
                    {total ?? <NoData text='No data' className='VehiclesList__text--gray' />}
                </span>
            </li>
            {groups.map(group =>
                group?.map(vehicle => <VehicleItem key={vehicle.vin} vehicle={vehicle} onClick={onClick} />)
            )}
        </ul>
    );
};

export default VehiclesList;
